/**
 * Product page JS — gallery, accordion, variant selection, cart AJAX, sticky CTA
 */

(function() {
  'use strict';

  /**
   * Sestaví srcset z Shopify CDN URL nahrazením width parametru.
   * Shopify URL vzor: .../file.jpg?v=xxx&width=NNN nebo .../file.jpg?width=NNN
   * Pokud URL žádný width param nemá, přidá ho.
   */
  function buildSrcset(baseUrl) {
    var widths = [600, 900, 1200, 1800, 2400];
    return widths.map(function(w) {
      var url;
      if (/[?&]width=\d+/.test(baseUrl)) {
        url = baseUrl.replace(/([\?&]width=)\d+/, '$1' + w);
      } else {
        url = baseUrl + (baseUrl.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w;
      }
      return url + ' ' + w + 'w';
    }).join(', ');
  }



  const productDataEl = document.querySelector('[data-product-json]');
  if (!productDataEl) return;

  const product = JSON.parse(productDataEl.textContent);
  const form = document.getElementById('product-form');
  const variantInput = form ? form.querySelector('[data-variant-id]') : null;
  const mainImage = document.querySelector('[data-product-main-image]');
  const thumbnails = document.querySelectorAll('[data-product-thumb]');
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  const priceEl = document.querySelector('[data-product-price]');
  const stockEl = document.querySelector('[data-stock-indicator]');
  const stickyCta = document.querySelector('[data-sticky-cta]');
  const stickyAddBtn = document.querySelector('[data-sticky-add-to-cart]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const deliveryInfoEl = document.querySelector('[data-delivery-info]');
  const preorderDateEl = document.querySelector('[data-preorder-date]');
  const preorderNoticeEl = document.querySelector('[data-preorder-notice]');
  const titleEl = document.querySelector('.product-page__title');
  const stickyTitleEl = document.querySelector('.product-page__sticky-title');
  const baseTitle = product.title;

  const inventoryPoliciesEl = document.querySelector('[data-inventory-policies]');
  const inventoryPolicies = inventoryPoliciesEl ? JSON.parse(inventoryPoliciesEl.textContent) : {};

  // DF-06: navázat ATC submit handler BRZY — před heavy synchronním initem níže (resolve
  // varianty, render ceny, galerie). Jinak klik, co dorazí dřív než se listener naváže
  // (~ř. 363), propadne do nativního form POST a AJAX/drawer se nespustí ("ztracený první
  // klik", nejhorší na pomalých zařízeních). onProductSubmit je hoistovaná deklarace; čte
  // variantInput/qtyInput líně až při submitu (variantInput má SSR current_variant.id, ne NaN).
  if (form) form.addEventListener('submit', onProductSubmit);

  // Preorder = inventory_policy continue AND fyzicky vyprodáno (qty<=0).
  // JSON blob data-inventory-policies obsahuje {policy, qty} per variant ID.
  function isPreorder(variant) {
    var data = inventoryPolicies[variant.id];
    // Podpora obou formátů: starý (string) i nový ({policy, qty})
    var policy = (data && typeof data === 'object') ? data.policy
               : (typeof data === 'string' ? data : variant.inventory_policy);
    if (policy !== 'continue') return false;

    // Qty z Liquid blobu (nejspolehlivější — multi-location safe díky | plus: 0)
    if (data && typeof data === 'object' && typeof data.qty === 'number') {
      return data.qty <= 0;
    }
    // Fallback: qty z product JSON (Shopify ho obvykle posílá pro single-location)
    if (typeof variant.inventory_quantity === 'number') return variant.inventory_quantity <= 0;
    // Nesmíme použít variant.available — CONTINUE policy ji nastaví na true i při qty=0
    return false;
  }

  // ============================================================
  // Gallery — helper pro přepínání obrázku (bez lightboxu)
  // ============================================================
  var imageCounter = document.querySelector('[data-image-counter-current]');
  var currentGalleryIndex = 0;

  function switchGalleryImage(index) {
    var thumbArr = Array.from(thumbnails);
    var thumb = thumbArr[index];
    if (!thumb) return;
    var url = thumb.getAttribute('data-image-url');
    if (mainImage && url) {
      currentGalleryIndex = index;
      mainImage.src = url;
      mainImage.srcset = buildSrcset(url);
      mainImage.sizes = '(max-width: 999px) 100vw, (max-width: 1400px) calc(58vw - 108px), 660px';
      thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (imageCounter) imageCounter.textContent = index + 1;
      mainImage.onload = function() { updateZoomState(); };
    }
  }

  // Thumbnail klik — pouze přepne hlavní obrázek (lightbox se neotvírá)
  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var index = parseInt(this.getAttribute('data-image-index'));
      switchGalleryImage(index);
    });
  });

  // ============================================================
  // Gallery — touch/swipe support (mobile) — jen přepínání, bez lightboxu
  // ============================================================
  var touchStartX = 0;
  var touchEndX = 0;
  var galleryEl = document.querySelector('.product-page__main-image-wrap');

  if (galleryEl && thumbnails.length > 1) {
    galleryEl.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    galleryEl.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) < 40) return;

      var thumbArr = Array.from(thumbnails);
      var activeThumb = document.querySelector('[data-product-thumb].is-active');
      var activeIndex = activeThumb ? parseInt(activeThumb.getAttribute('data-image-index')) : 0;
      var nextIndex = diff > 0
        ? Math.min(activeIndex + 1, thumbArr.length - 1)
        : Math.max(activeIndex - 1, 0);

      // switchGalleryImage — jen přepnutí, swipe neotevírá lightbox
      if (nextIndex !== activeIndex) {
        switchGalleryImage(nextIndex);
      }
    }, { passive: true });
  }

  // ============================================================
  // Variant selection
  // ============================================================

  // On page load: update variant state (cena, stock, preorder) pro výchozí nebo ?variant= variantu
  (function() {
    var urlVariantId = new URLSearchParams(window.location.search).get('variant');
    var targetVariant = null;

    if (urlVariantId) {
      targetVariant = product.variants.find(function(v) { return String(v.id) === String(urlVariantId); });
      if (targetVariant && targetVariant.sku && targetVariant.sku.indexOf('jackery-') === 0 && targetVariant.sku.indexOf('jackery-set-') !== 0 && targetVariant.sku !== product.handle) {
        window.location.replace('/products/' + targetVariant.sku);
        return;
      }
      // Search API sometimes returns a Set variant ID — ignore it, fall through to standalone fallback
      if (targetVariant && targetVariant.options && targetVariant.options.some(function(opt) { return opt.indexOf('Set ') === 0; })) {
        targetVariant = null;
      }
    }

    if (!targetVariant) {
      // Bez ?variant= param — urči výchozí variantu ze selectů (nebo první varianta)
      var selectedOptions = [];
      document.querySelectorAll('.product-page__option-select:not([data-family-nav])').forEach(function(s) {
        selectedOptions.push(s.value);
      });
      if (selectedOptions.length > 0) {
        targetVariant = product.variants.find(function(v) {
          return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
        });
      }
      if (!targetVariant) {
        // Skip 'Set +' redirect variants — same rule as Liquid template
        targetVariant = product.variants.find(function(v) {
          return v.options.every(function(opt) { return opt.indexOf('Set + ') === -1; });
        }) || product.variants[0];
      }
    }

    if (targetVariant) updateVariant(targetVariant);
  })();

  var optionSelects = document.querySelectorAll('.product-page__option-select:not([data-family-nav])');

  optionSelects.forEach(function(sel) {
    sel.addEventListener('change', function() {
      // Build selected options from all selects (exclude family nav)
      var selectedOptions = [];
      document.querySelectorAll('.product-page__option-select:not([data-family-nav])').forEach(function(s) {
        selectedOptions.push(s.value);
      });

      // Find matching variant
      var matchedVariant = product.variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      });

      if (!matchedVariant) return;

      // If variant SKU is a product handle (sets or batteries), redirect to that product
      if (matchedVariant.sku && matchedVariant.sku.indexOf('jackery-') === 0 && matchedVariant.sku.indexOf('jackery-set-') !== 0 && matchedVariant.sku !== product.handle) {
        window.location.href = '/products/' + matchedVariant.sku;
        return;
      }

      updateVariant(matchedVariant);
    });
  });

  function updateVariant(variant) {
    // Update hidden input
    if (variantInput) variantInput.value = variant.id;

    // Update URL
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Update product title based on selected variant
    if (titleEl || stickyTitleEl) {
      var displayTitle = baseTitle;
      // Set/skládaná varianta = obsahuje " + " (panel/baterie navíc). Language-agnostic:
      // funguje pro CZ i přeložené SK option values (samostatné varianty " + " nemají).
      if (variant.title && variant.title !== 'Default Title' && variant.title.indexOf(' + ') !== -1) {
        // "Set + SolarSaga 100W" → "Explorer 1000 V2 + SolarSaga 100W"
        // Split odstraní případný set-suffix z titulku produktu (formát "Název — Set + Panel")
        var cleanBase = baseTitle.split(/\s[—–]\s/)[0].trim();
        var panelPart = variant.title.replace(/^Set \+ /, '');
        displayTitle = cleanBase + ' + ' + panelPart;
      }
      if (titleEl) titleEl.textContent = displayTitle;
      if (stickyTitleEl) stickyTitleEl.textContent = displayTitle.length > 32 ? displayTitle.slice(0, 31) + '…' : displayTitle;
    }

    // Update price
    if (priceEl) {
      var priceHtml = '';
      // Pre-compute "cena bez DPH" — only show if priceEl had it on initial render
      // (Liquid guards on shop.taxes_included + settings.show_price_no_vat).
      var showNoVat = !!priceEl.querySelector('[data-product-price-novat]');
      var noVatHtml = '';
      if (showNoVat) {
        // VAT divisor z window.JackeryConfig (market-aware, injektovaný z vat-rate snippetu dle localization.country), fallback 1.21.
        // Zaokrouhlení měnově závislé (money.digits, zrcadlí snippet currency-decimals):
        // CZK/HUF → celé jednotky (retail konvence), EUR/RON → v centech, jinak se centy zahodí
        // (249,01 € / 1,23 = 202,45 € se renderovalo jako 202 €).
        var vatDiv = (window.JackeryConfig && window.JackeryConfig.vatDivisor) || 1.21;
        var moneyCfg = (window.JackeryConfig && window.JackeryConfig.money) || {};
        var priceNoVat = moneyCfg.digits === 0
          ? Math.round(variant.price / 100 / vatDiv) * 100
          : Math.round(variant.price / vatDiv);
        noVatHtml = '<div class="product-page__no-vat" data-product-price-novat>' + formatMoney(priceNoVat) + ' ' + jcI18n('noVatSuffix', 'bez DPH') + '</div>';
      }
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var saveAmount = variant.compare_at_price - variant.price;
        var savePercent = Math.round((saveAmount / variant.compare_at_price) * 100);
        priceHtml += '<div class="product-page__price-row">';
        priceHtml += '<span class="product-page__price-current product-page__price-current--sale">' + formatMoney(variant.price) + '</span>';
        priceHtml += '<span class="product-page__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
        priceHtml += '</div>';
        priceHtml += '<div class="product-page__price-meta">';
        priceHtml += '<span class="product-page__price-save"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> ' + jcI18n('saveWord', 'Ušetříte') + ' ' + formatMoney(saveAmount) + ' (' + savePercent + '%)</span>';
        priceHtml += '<span class="product-page__vat">' + jcI18n('inclVat', 'vč. DPH') + '</span>';
        priceHtml += '</div>';
      } else {
        priceHtml += '<div class="product-page__price-row">';
        priceHtml += '<span class="product-page__price-current">' + formatMoney(variant.price) + '</span>';
        priceHtml += '</div>';
        priceHtml += '<div class="product-page__price-meta"><span class="product-page__vat">' + jcI18n('inclVat', 'vč. DPH') + '</span></div>';
      }
      priceHtml += noVatHtml;
      priceEl.innerHTML = priceHtml;
    }

    // Update sticky price
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(variant.price);
      // fix #4: sync sale class so sticky price colour matches main price
      stickyPrice.classList.toggle(
        'product-page__price-current--sale',
        !!(variant.compare_at_price && variant.compare_at_price > variant.price)
      );
    }

    // Update stock
    var preorder = isPreorder(variant);
    if (stockEl) {
      stockEl.className = 'stock-indicator';
      if (preorder) {
        stockEl.classList.add('stock-indicator--preorder');
        stockEl.innerHTML = '<span class="stock-indicator__dot"></span> ' + jcI18n('preorder', 'Předobjednávka');
      } else if (variant.available) {
        stockEl.classList.add('stock-indicator--in-stock');
        stockEl.innerHTML = '<span class="stock-indicator__dot"></span> ' + jcI18n('inStock', 'Skladem');
      } else {
        stockEl.classList.add('stock-indicator--out');
        stockEl.innerHTML = '<span class="stock-indicator__dot"></span> ' + jcI18n('soldOut', 'Vyprodáno');
      }
    }

    // Update preorder notice + date + delivery info
    if (preorderNoticeEl) preorderNoticeEl.style.display = preorder ? '' : 'none';
    if (preorderDateEl) preorderDateEl.style.display = preorder ? '' : 'none';
    if (deliveryInfoEl) deliveryInfoEl.style.display = (preorder || !variant.available) ? 'none' : '';

    // Update buy button
    if (addToCartBtn) {
      if (preorder) {
        addToCartBtn.disabled = false;
        addToCartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="none"/></svg> ' + jcI18n('preorderBtn', 'Předobjednat');
      } else if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 001.6-1.61L23 6H6"/><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/></svg> ' + jcI18n('addToCart', 'Přidat do košíku');
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = jcI18n('unavailable', 'Nedostupné');
      }
    }
    if (stickyAddBtn) {
      stickyAddBtn.disabled = !variant.available && !preorder;
    }

    // Update image if variant has featured image
    if (variant.featured_image && variant.featured_image.src && mainImage) {
      var variantImageId = variant.featured_image.id;
      var variantFilename = variant.featured_image.src.split('?')[0].split('/').pop();
      var matchedThumb = null;

      // 1) Shoda podle image ID (data-image-id) — spolehlivé po výměně obrázků
      thumbnails.forEach(function(t) {
        var tid = t.getAttribute('data-image-id');
        if (tid && variantImageId && String(tid) === String(variantImageId)) {
          matchedThumb = t;
        }
      });

      // 2) Fallback: shoda podle části jména souboru (bez přípony a ID suffixu)
      if (!matchedThumb && variantFilename) {
        var baseFilename = variantFilename.split('.')[0].replace(/__\d+$/, '');
        thumbnails.forEach(function(t) {
          if (matchedThumb) return;
          var thumbUrl = t.getAttribute('data-image-url') || '';
          if (thumbUrl.includes(variantFilename) || (baseFilename.length > 5 && thumbUrl.includes(baseFilename))) {
            matchedThumb = t;
          }
        });
      }

      if (matchedThumb) {
        // Nalezena shoda — přepni aktivní thumb a hlavní obrázek
        thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
        matchedThumb.classList.add('is-active');
        var newUrl = matchedThumb.getAttribute('data-image-url');
        mainImage.src = newUrl;
        mainImage.srcset = buildSrcset(newUrl);
        mainImage.sizes = '(max-width: 999px) 100vw, (max-width: 1400px) calc(58vw - 108px), 660px';
      }
      // Pokud shoda nenalezena (obrázky byly vyměněny), ponech SSR stav beze změny
      // — server již vykreslil správný první obrázek a první thumb jako is-active
    }
  }

  // ============================================================
  // Quantity selector
  // ============================================================
  var qtyInput = document.querySelector('[data-qty-input]');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // ============================================================
  // Add to cart AJAX
  // ============================================================
  var cartErrTimer;

  // DF-06: hoistovaná deklarace — registrovaná brzy nahoře (viz `addEventListener('submit', onProductSubmit)`).
  function onProductSubmit(e) {
      e.preventDefault();
      // fix #3: guard against missing [data-variant-id] input
      if (!variantInput) {
        console.error('jackery: [data-variant-id] missing');
        return;
      }
      var currentVariant = product.variants.find(function(v) {
        return String(v.id) === String(variantInput.value);
      });
      var cartItem = {
        id: parseInt(variantInput.value),
        quantity: parseInt(qtyInput ? qtyInput.value : 1)
      };
      if (currentVariant && isPreorder(currentVariant)) {
        cartItem.properties = {};
        cartItem.properties[jcI18n('preorderProp', 'Předobjednávka')] = jcI18n('preorderPropVal', 'Expedice jakmile bude zboží skladem');
      }
      var formData = { items: [cartItem] };

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = jcI18n('adding', 'Přidávání...');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      // fix #1: check res.ok before treating as success
      .then(function(res) {
        if (!res.ok) return res.json()
          .catch(function() { throw { description: jcI18n('addUnavailable', 'Zboží momentálně není dostupné') }; })
          .then(function(err) { throw err; });
        return res.json();
      })
      .then(function() {
        addToCartBtn.textContent = jcI18n('added', 'Přidáno ✓');

        setTimeout(function() {
          addToCartBtn.disabled = false;
          var cv = product.variants.find(function(v) { return String(v.id) === String(variantInput.value); });
          if (cv && isPreorder(cv)) {
            addToCartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="none"/></svg> ' + jcI18n('preorderBtn', 'Předobjednat');
          } else {
            addToCartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 001.6-1.61L23 6H6"/><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/></svg> ' + jcI18n('addToCart', 'Přidat do košíku');
          }
        }, 2000);

        // Update cart count in header
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var countEl = document.querySelector('[data-cart-count]');
            if (countEl) countEl.textContent = cart.item_count;
          });

        // Signal external add (triggers count badge bump in cart drawer)
        document.dispatchEvent(new CustomEvent('cart:added', {
          detail: { variantId: formData.items[0].id }
        }));

        // Open cart drawer
        var drawer = document.getElementById('cart-drawer');
        if (drawer) {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        addToCartBtn.disabled = false;
        var ecv = product.variants.find(function(v) { return String(v.id) === String(variantInput.value); });
        if (ecv && isPreorder(ecv)) {
          addToCartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="none"/></svg> ' + jcI18n('preorderBtn', 'Předobjednat');
        } else {
          addToCartBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 001.6-1.61L23 6H6"/><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/></svg> ' + jcI18n('addToCart', 'Přidat do košíku');
        }
        // fix #1: show inline error message under the button
        var msg = (err && err.description) ? err.description
                : (err && err.message) ? err.message
                : jcI18n('addUnavailable', 'Zboží momentálně není dostupné');
        var errEl = form.querySelector('.cart-err') || document.createElement('p');
        errEl.className = 'cart-err';
        errEl.style.cssText = 'color:#dc2626;font-size:.85rem;margin-top:8px;';
        errEl.textContent = msg;
        if (!errEl.parentNode) addToCartBtn.insertAdjacentElement('afterend', errEl);
        clearTimeout(cartErrTimer);
        cartErrTimer = setTimeout(function() {
          if (errEl.parentNode) errEl.parentNode.removeChild(errEl);
        }, 5000);
      });
  }

  // Sticky add to cart button click → submit form
  if (stickyAddBtn && form) {
    stickyAddBtn.addEventListener('click', function() {
      // fix #3: bubbles: true to match native submit event behaviour
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  // ============================================================
  // Accordion
  // ============================================================
  document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var item = this.closest('.accordion__item');
      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        item.classList.remove('is-open');
        this.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ============================================================
  // Sticky mobile CTA (IntersectionObserver)
  // ============================================================
  if (stickyCta && addToCartBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyCta.style.display = 'none';
        } else {
          stickyCta.style.display = 'block';
        }
      });
    }, { threshold: 0 });

    observer.observe(addToCartBtn);
  }

  // ============================================================
  // Price formatter
  // ============================================================
  function jcI18n(key, fallback) {
    return (window.JackeryConfig && window.JackeryConfig.i18n && window.JackeryConfig.i18n[key]) || fallback;
  }
  function formatMoney(cents) {
    if (window.JackeryMoney && typeof window.JackeryMoney.format === 'function') {
      return window.JackeryMoney.format(cents);
    }
    // market-aware: CZK byte-identické ("2.899 Kč"), EUR byte-identické ("294,94 €").
    // Nové měny (HUF, RON…): Intl.NumberFormat pro správný locale-specific formát.
    // DF-01: JS přepisuje Liquid render → musí používat stejný symbol/magnitude jako presentment měna.
    // DF-03 (2026-07-15): CZK oddělovač tisíců = MEZERA (česká norma) — byte-identical s money_format
    //   {{amount_with_space_separator}} (změněn v adminu 2026-07-15). Dřív byla tečka (staré money_format).
    var jc = (window.JackeryConfig && window.JackeryConfig.money) || {};
    // JackeryConfig.money sets currency+locale but NOT symbol (theme.liquid), so derive the symbol
    // from the currency: EUR → '€' (SK), else 'Kč' (CZ byte-identical). Without this the EUR branch
    // fell back to 'Kč' → SK PDP showed "83,26 Kč" instead of "83,26 €" (correct magnitude, wrong symbol).
    var symbol = jc.symbol || (jc.currency === 'EUR' ? '€' : 'Kč');
    if (jc.currency === 'CZK') {
      var amount = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return amount + ' ' + symbol;
    }
    if (jc.currency === 'EUR') {
      return (cents / 100).toLocaleString(jc.locale || 'sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + symbol;
    }
    try {
      return new Intl.NumberFormat(jc.locale || 'en', { style: 'currency', currency: jc.currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + symbol;
    }
  }

  // ============================================================
  // Zoom state — skryj zoom hint a zakáž lightbox u malých obrázků
  // ============================================================
  var zoomHint = document.querySelector('.product-page__image-zoom-hint');
  var MIN_ZOOM_WIDTH = 400; // px — blokuje jen skutečně miniaturní obrázky (< 400px nativní šířky)

  function updateZoomState() {
    var nw = mainImage ? mainImage.naturalWidth : 0;
    if (nw > 0 && nw < MIN_ZOOM_WIDTH) {
      if (mainImage) mainImage.style.cursor = 'default';
      if (zoomHint) zoomHint.style.display = 'none';
    } else {
      if (mainImage) mainImage.style.cursor = '';
      if (zoomHint) zoomHint.style.display = '';
    }
  }

  // Při prvním načtení stránky
  if (mainImage) {
    if (mainImage.complete) {
      updateZoomState();
    } else {
      mainImage.addEventListener('load', updateZoomState);
    }
  }

  // ============================================================
  // Image zoom / lightbox s navigací
  // ============================================================
  var mainImageWrap = document.querySelector('.product-page__main-image-wrap');
  var lightbox = document.getElementById('product-lightbox');
  var lightboxImg = document.getElementById('product-lightbox-img');
  var lightboxClose = document.getElementById('product-lightbox-close');
  var lightboxPrev = document.getElementById('product-lightbox-prev');
  var lightboxNext = document.getElementById('product-lightbox-next');
  var lightboxCounter = document.getElementById('product-lightbox-counter');

  // Sesbírej všechny obrázky produktu z thumbnailu
  var allThumbs = Array.from(document.querySelectorAll('[data-product-thumb]'));
  var lightboxImages = [];
  var lightboxIndex = 0;

  function buildLightboxImages() {
    // Priorita: thumbnaile (mají data-image-url ve vysokém rozlišení)
    if (allThumbs.length > 0) {
      lightboxImages = allThumbs.map(function(btn) {
        return {
          url: btn.getAttribute('data-image-url') || '',
          alt: btn.querySelector('img') ? btn.querySelector('img').alt : ''
        };
      });
    } else {
      // Fallback: jen aktuální hlavní obrázek
      lightboxImages = [{ url: mainImage ? mainImage.src : '', alt: '' }];
    }
  }

  function openLightbox(index) {
    buildLightboxImages();
    lightboxIndex = Math.max(0, Math.min(index, lightboxImages.length - 1));
    updateLightboxImage();
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function updateLightboxImage() {
    var item = lightboxImages[lightboxIndex];
    if (!item) return;
    // Upgrade na 2400px pro zoom kvalitu
    var src = item.url.replace(/([\?&]width=)\d+/, '$12400');
    lightboxImg.src = src;
    lightboxImg.alt = item.alt || '';
    lightboxImg.style.maxWidth = '';

    // Counter
    if (lightboxCounter) {
      if (lightboxImages.length > 1) {
        lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxImages.length;
        lightboxCounter.style.display = '';
      } else {
        lightboxCounter.style.display = 'none';
      }
    }

    // Šipky — disable na krajích
    if (lightboxPrev) lightboxPrev.disabled = lightboxIndex === 0;
    if (lightboxNext) lightboxNext.disabled = lightboxIndex === lightboxImages.length - 1;

    // Skryj šipky pokud jen 1 obrázek
    var showNav = lightboxImages.length > 1;
    if (lightboxPrev) lightboxPrev.style.display = showNav ? '' : 'none';
    if (lightboxNext) lightboxNext.style.display = showNav ? '' : 'none';
  }

  function lightboxGoTo(index) {
    lightboxIndex = Math.max(0, Math.min(index, lightboxImages.length - 1));
    updateLightboxImage();
    // Syncing galerie — po zavření lightboxu zákazník vidí naposledy prohlížený obrázek
    switchGalleryImage(lightboxIndex);
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (mainImageWrap && lightbox && mainImage) {
    // Otevření: klik na hlavní obrázek (handler jen na main-image-wrap, ne na celý gallery div)
    mainImageWrap.addEventListener('click', function(e) {
      // Listener je jen na .product-page__main-image-wrap — thumbnaily jsou v jiném DOM větvi
      // Přesto guard pro případné potomky s button rolí (badge, overlay)
      if (e.target.closest('button')) return;
      // Použijeme trackovatelný index místo DOM query — spolehlivé i při race condition po přepnutí obrázku
      openLightbox(currentGalleryIndex);
    });

    // Navigace — šipky
    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', function(e) {
        e.stopPropagation();
        lightboxGoTo(lightboxIndex - 1);
      });
    }
    if (lightboxNext) {
      lightboxNext.addEventListener('click', function(e) {
        e.stopPropagation();
        lightboxGoTo(lightboxIndex + 1);
      });
    }

    // Zavření
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) closeLightbox();
    });

    // Klávesnice: ESC, ←, →
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxGoTo(lightboxIndex - 1);
      if (e.key === 'ArrowRight') lightboxGoTo(lightboxIndex + 1);
    });

    // Swipe na mobilu
    var touchStartX = 0;
    lightbox.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) {
        lightboxGoTo(lightboxIndex + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
  }

})();
